export default __webpack_public_path__ + "static/differentiate-headings-dont-acc1f73b1019d130294884d16a6fd52e9ed699aa19a9b2df52728b41c7913bec.png";